import { Logradouro } from '@tivic-team/manager-ts/dist/grl';
import { TaxiPonto } from '@tivic-team/manager-ts/dist/mob/entities/taxi/taxi-ponto.entity';
export class TaxiPontoDTO extends TaxiPonto{
    
    logradouro: Logradouro;
    
    constructor(){
        super();
    }
}

export class TaxiPontoListDTO {
    items: Array<TaxiPontoDTO>;
    total: number;
    constructor() {}
}